import { Fragment, useEffect, useRef } from "react";
import { MessagesSquare } from "lucide-react";
import { ChatBubble } from "@/components/chat/ChatBubble";
import { fmtDay } from "@/lib/chat";

const dayKey = (iso) => new Date(iso).toLocaleDateString("en-CA", { timeZone: "Asia/Jakarta" });

export const ChatThread = ({ messages, viewer, emptyText }) => {
  const end = useRef(null);
  const last = messages?.[messages.length - 1]?.msg_id;
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [last]);

  return (
    <div className="flex-1 overflow-y-auto px-3 py-3 bg-[#efeae2] dark:bg-[#0b141a]"
      style={{ backgroundImage: "radial-gradient(rgba(0,0,0,0.045) 1px, transparent 1px)", backgroundSize: "18px 18px" }} data-testid="chat-thread">
      {messages?.length === 0 && (
        <div className="h-full flex flex-col items-center justify-center text-center text-slate-500 gap-2 py-10" data-testid="chat-empty">
          <MessagesSquare className="h-10 w-10 text-emerald-600" />
          <p className="text-sm max-w-[240px]">{emptyText}</p>
        </div>
      )}
      {messages?.map((m, i) => (
        <Fragment key={m.msg_id}>
          {(i === 0 || dayKey(messages[i - 1].created_at) !== dayKey(m.created_at)) && (
            <div className="flex justify-center my-2"><span className="text-[11px] bg-white/90 text-slate-600 rounded-lg px-3 py-1 shadow-sm">{fmtDay(m.created_at)}</span></div>
          )}
          <ChatBubble m={m} viewer={viewer} />
        </Fragment>
      ))}
      <div ref={end} />
    </div>
  );
};
